import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { MarginBottom } from '../styles';
import { SelectTag } from 'shared/ui/select/selectTag';
import { FC } from 'react';

interface OrderTagsFilterProps {
	tagsOptions: any;
	selectedTagsOptions: any;
	changeTags: any;
}

export const OrderTagsFilter: FC<OrderTagsFilterProps> = ({
	tagsOptions,
	selectedTagsOptions,
	changeTags,
}) => {
  const Label = withTypographyContainer(Typography);

	return (
		<MarginBottom>
			<div>
				<Label colorVariant={'main'} isBold={true}>
					Теги бронирования
				</Label>
				<SelectTag
					options={tagsOptions}
					value={selectedTagsOptions}
					onSelect={changeTags}
					placeholder="Выберите тэги"
				/>
			</div>
		</MarginBottom>
	);
};
